import { ApiTags } from '@constants/common';
import restApi from '@services/api';
import { GenericApiResponse } from '@type/general';
import { City, Country, Currency, Sector, State, TimeZone } from '@type/util';

const CreateCompanyApi = restApi.injectEndpoints({
  endpoints: builder => ({
    getCountry: builder.query<Country[], { searchTerm?: string }>({
      query: payload => ({
        url: `${process.env.REACT_APP_BASE_API_VERSION}/support/utils/country${
          payload.searchTerm ? `?search=${payload.searchTerm}` : ''
        }`,
        method: 'GET'
      }),
      providesTags: [],
      transformResponse: (response: { status: string; result: Country[] }) =>
        response.result
    }),
    getState: builder.query<State[], { searchTerm?: string; country: string }>({
      query: payload => ({
        url: `${
          process.env.REACT_APP_BASE_API_VERSION
        }/support/utils/state${`?country=${payload.country}`}${
          payload.searchTerm ? `&search=${payload.searchTerm}` : ''
        }`,
        method: 'GET'
      }),
      providesTags: [],
      transformResponse: (response: { status: string; result: State[] }) =>
        response.result
    }),
    getCity: builder.query<
      City[],
      { searchTerm?: string; country: string; state: string }
    >({
      query: payload => ({
        url: `${
          process.env.REACT_APP_BASE_API_VERSION
        }/support/utils/city${`?country=${payload.country}&state=${payload.state}`}${
          payload.searchTerm ? `&search=${payload.searchTerm}` : ''
        }`,
        method: 'GET'
      }),
      providesTags: [],
      transformResponse: (response: { status: string; result: City[] }) =>
        response.result
    }),
    getCurrency: builder.query<Currency[], { searchTerm?: string }>({
      query: payload => ({
        url: `${process.env.REACT_APP_BASE_API_VERSION}/support/utils/currency${
          payload.searchTerm ? `?search=${payload.searchTerm}` : ''
        }`,
        method: 'GET'
      }),
      providesTags: [],
      transformResponse: (response: { status: string; result: Currency[] }) =>
        response.result
    }),
    getTimezone: builder.query<TimeZone[], void>({
      query: () => ({
        url: `${process.env.REACT_APP_BASE_API_VERSION}/support/utils/timezone`,
        method: 'GET'
      }),
      providesTags: [],
      transformResponse: (response: { status: string; result: TimeZone[] }) =>
        response.result
    }),
    getSector: builder.query<Sector[], void>({
      query: () => ({
        url: `${process.env.REACT_APP_BASE_API_VERSION}/support/utils/sector`,
        method: 'GET'
      }),
      providesTags: [ApiTags.sector],
      transformResponse: (response: { status: string; result: Sector[] }) =>
        response.result
    }),
    createSector: builder.mutation<
      GenericApiResponse<string>,
      { sector_name: string }
    >({
      query: payload => ({
        url: `${process.env.REACT_APP_BASE_API_VERSION}/support/utils/sector`,
        method: 'POST',
        body: payload
      }),
      invalidatesTags: [ApiTags.sector],
      transformResponse: (response: { status: string; result: string }) =>
        response
    })
  })
});

export const {
  useGetCountryQuery,
  useLazyGetCountryQuery,
  useGetStateQuery,
  useLazyGetStateQuery,
  useGetCityQuery,
  useLazyGetCityQuery,
  useGetCurrencyQuery,
  useGetTimezoneQuery,
  useLazyGetTimezoneQuery,
  useCreateSectorMutation,
  useGetSectorQuery
} = CreateCompanyApi;
